// extracted by mini-css-extract-plugin
export default {"listContainer":"ListContainer_listContainer__3dOXs","tag":"ListContainer_tag__L7vNL","tagBgGray":"ListContainer_tagBgGray__mU-Im"};